export enum ReasonCode {
    USER_PROFILE_INCOMPLETE = 'user_profile_incomplete',
    CART_IS_PAID = 'cart_is_paid'
}
